import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function ThreeInspectionDanger() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
